import { CSSProperties } from 'react';
import { CircleCountWidget } from './useStyles.';

interface CircleCountProps {
  number: number;
  customStyle?: CSSProperties;
}

const CircleCount = ({ number, customStyle }: CircleCountProps) => {
  return (
    <CircleCountWidget style={{ ...customStyle }}>{number}</CircleCountWidget>
  );
};

export default CircleCount;
